@import '../styles/_vars.css';

.content + .ctaContainer {
  margin-top: 30px;
}

.content h2 {
  font-size: 2.4em;
  margin-bottom: 0.9em;
}

.content h3 {
  font-size: 1.8em;
  margin-bottom: 0.2em;
}

.cta {
  margin-top: 2em;
}

.ctaContainer {
  align-items: center;
  display: flex;
  flex-flow: column;
  gap: 1.5rem;
  justify-content: center;
  align-items: center;
}

.ctaContainer a {
  width: max-content;
}

.testimonials {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 250px;
  padding-bottom: 4em;
  padding-top: 4em;
  text-align: center;
  background-size: cover;
  background-repeat: no-repeat;
}

@media screen and (min-width: 770px) {
  .ctaContainer {
    align-items: flex-start;
    flex-flow: row wrap;
    align-items: center;
    justify-content: flex-start;
  }

  .ctaContainer a {
    flex: 0 0 auto;
    width: max-content;
    padding-left: 1.25em;
    padding-right: 1.25em;
  }
}
